// Foretaksopplysninger — hentet fra Brønnøysundregistrene (Enhetsregisteret).
// Org.nr 833 727 982 · https://virksomhet.brreg.no/nb/oppslag/enheter/833727982
export const company = {
  name: 'Bjørnå IT',
  legalName: 'BJØRNÅ IT',
  orgNr: '833 727 982',
  orgForm: 'Enkeltpersonforetak',
  registered: '19.07.2024',
  registeredInForetaksregisteret: true,
  naeringskode: '62.100 – Dataprogrammeringstjenester',
  city: 'Mosjøen',
  municipality: 'Vefsn',
  email: 'kontakt@bjornaait.no',
  brregUrl: 'https://virksomhet.brreg.no/nb/oppslag/enheter/833727982',
};
